import React from 'react';

function SearchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g>
        <path
          fill="#0A0A0A"
          d="M24 22.587l-6.262-6.262a10.016 10.016 0 10-1.414 1.414L22.586 24 24 22.587zM10 18a8 8 0 118-8 8.009 8.009 0 01-8 8z"
        ></path>
      </g>
    </svg>
  );
}

export default SearchIcon;
